import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const PopupWrapper = styled.div`
	position: absolute;
	top: 28px;
	right: 0;
	width: 240px;
	padding: 12px;
	background: #FFFFFF;
	border: 1px solid ${Colors.gray};
	border-radius: 8px;
	box-shadow: rgb(220, 220, 220, 0.8) 0px 7px 29px 0px;
	opacity: 0;
	visibility: hidden;
	transform: translateY(4px);
	transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
	z-index: 2;
`;

export const PopupTitle = styled.h5`
	margin: 0 0 8px 0;
	font-size: 14px;
	font-weight: 700;
	color: ${Colors.black};
`;

export const PopupParagraph = styled.p`
	margin: 0;
	font-size: 13px;
	line-height: 18px;
	color: ${Colors.black};
	white-space: pre-line;
    margin-bottom: 8px;
`;
